<template>
  <div class="flex flex-col">
    <div v-if="prescriptions.length>0 &&medCode==='chmedPrescriptionItem'" class="description-con">
      <el-descriptions border :column="2">
        <el-descriptions-item label="剂数">
          <div class="value">{{ info.head['doseNum'] }}</div>
        </el-descriptions-item>
        <el-descriptions-item label="天数">
          <div class="value">{{ info.head["dayNum"] }}</div>
        </el-descriptions-item>
        <el-descriptions-item label="次/日">
          <div class="value">{{ info.head["dayDoseNum"] }}</div>
        </el-descriptions-item>
        <el-descriptions-item label="剂/日">
          <div class="value">{{ info.head["dayFreq"] }}</div>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <el-table
      v-if="prescriptions.length>0"
      :data="info.body[medCode]"
      border
      header-row-class-name="header-row"
      header-cell-class-name="header-row"
    >
      <el-table-column prop="materielName" label="药品" align="center" />
      <el-table-column
        v-if="medCode==='chmedPrescriptionItem'"
        prop="singleNum"
        label="数量"
        align="center"
      />
      <el-table-column
        v-if="medCode==='medPrescriptionItem'"
        prop="sellingNum"
        label="数量"
        align="center"
      />
      <el-table-column
        v-if="medCode==='agentPrescriptionItem'"
        prop="sellingNum"
        label="数量"
        align="center"
      />
      <el-table-column
        v-if="medCode==='chagentPrescriptionItem'"
        prop="sellingNum"
        label="数量"
        align="center"
      />
      <el-table-column
        v-if="medCode==='servePrescriptionItem'"
        prop="sellingNum"
        label="数量"
        align="center"
      />
      <el-table-column
        v-if="medCode==='chmedPrescriptionItem'"
        prop="decoctionName"
        label="煎法"
        align="center"
      />
      <el-table-column prop="meaUomName" label="单位" align="center" />
    </el-table>
  </div>
</template>

<script>
import { findAll, getById } from "@/api/ik/data/dataApi"

export default {
  name: "TreatmentRecord",
  props: {
    url: {
      type: String,
      required: true
    },
    medCode: {
      type: String,
      default: "chmedPrescriptionItem"
    }
  },
  data() {
    return {
      data: [],
      prescriptions: [],
      info: {
        head: {},
        body: {}
      }
    }
  },
  inject: ["pageData"],
  methods: {
    /**
     * 获取饮片处方
     * @param treatmentId
     */
    getPrescription(treatmentId) {
      const pd = {
        storeCode: this.pageData.storeCode,
        treatmentId
      }
      findAll(this.url, pd)
        .then(res => {
          this.prescriptions = res.data
          this.$emit("command", { type: "getData", data: this.prescriptions })
          if (res.data.length > 0) {
            getById(this.url, res.data[0].id)
              .then(prescription => {
                this.info = prescription.data
              })
          }
        })
    },
    /**
     * 获取info
     * @returns {{head: {}, body: {}}}
     */
    getInfo() {
      return this.info
    }

  }
}
</script>
<style>
.header-row {
  background: #F2F3F5 !important;
  border: 1px solid #E5E6EB;
}
</style>
<style scoped lang="scss">
.description-con {
  margin-bottom: 13px;

  .value {
    width: 45px;
  }
}
</style>
